import { VALIDATE_CHARACTER } from "common/Constants";

export const getAddRoleJson = (data, roleList) => {
  // console.log("getAddRoleJson ~ data----->", data)
  // console.log("g~ data----->", roleList)
  const AddRoleForm = {
    totalpages: 1,
    pages: [
      {
        modalView: false,
        colSpan: [24, 24, 24],
        fields: [
          [
            {
              id: 1,
              label: "Role Name",
              type: "text",
              name: "rolename",
              Placeholder: "Role Name",
              value: data["rolename"],
              maxLength: 35,
              validationRules: [
                {
                  required: true,
                  message: `Please enter your Role Name`,
                },
                {
                  validator: (rule, value) => {
                    if (roleList.some((data)=> data.roleName === value)) {
                      return Promise.reject("Role Already Exists");
                    }
                    return Promise.resolve();
                  },
                },
                // {
                //   validator: (rule, value, callback) => {
                //     if (value && !VALIDATE_CHARACTER.test(value)) {
                //       callback("Role Name should not contain special characters");
                //     } else {
                //       callback();
                //     }
                //   },
                // }
              ],
            },
          ],
          [
            {
              id: 2,
              label: "Next",
              type: "button",
              position: "end",
              textColor: "white",
              event: "submit",
            },
            // {
            //   id: 2,
            //   label: "Reset",
            //   type: "button",
            //   position: "end",
            //   textColor: "white",
            //   event: "submit",
            // },
          ],
        ],
      },
    ],
  };

  return {
    AddRoleForm,
  };
};
